import { AutogenModelEdibillingProfile, AutogenRowEdibillingProfile } from "./autogen/AutogenModelEdibillingProfile";

export class ModelEdibillingProfile extends AutogenModelEdibillingProfile<RowEdibillingProfile> {
	constructor() {
		super(RowEdibillingProfile);
	}
}

export class RowEdibillingProfile extends AutogenRowEdibillingProfile {
}